
const CUSTOM_FIELD_MAP = [
  ["searchShowJobTitle", "query"],
  ["searchShowSpeciality", "speciality"],
  ["searchShowGrade", "grade"],
  ["searchShowLocation", "location"],
  ["searchShowJobType", "job_type"],
  ["searchShowSalary", "salary"],
  ["searchShowRadius", "radius"],
];

export const resolveQuickSearchProps = (props = {}) => {
  const searchVariant = props.searchVariant || "classic";

  if (searchVariant === "custom") {
    const fields = CUSTOM_FIELD_MAP.filter(([prop]) => Boolean(props[prop])).map(([, key]) => key);
    return { variant: "full", fields: fields.length ? fields : null };
  }

  return { variant: searchVariant, fields: null };
};

export default resolveQuickSearchProps;
